import { render, staticRenderFns } from "./ManageTeam.vue?vue&type=template&id=0307b7f3&scoped=true&"
import script from "./ManageTeam.vue?vue&type=script&lang=ts&"
export * from "./ManageTeam.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTeam.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ManageTeam.vue?vue&type=style&index=1&id=0307b7f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0307b7f3",
  null
  
)

export default component.exports